import {GetMerchantInfoForProductSizeResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/merchant_info/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  ContentPopper,
  Flyout,
  ModalDialog,
  SecondaryContentPopperButton,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {MerchantLegalInfoContent} from './MerchantLegalInfoContent';

export const MerchantLegalInfoWrapperHandler: FC<
  GetMerchantInfoForProductSizeResponse & {
    onClose: VoidFunction;
  }
> = ({onClose, merchantInfo}) => {
  const {t} = useTranslation();

  return (
    <StyledContentPopper
      LayoutComponent={process.env.STACK === 'desktop' ? ModalDialog : Flyout}
      open
      renderInPortal
      fixedSmallWidth={false}
      data-testid="merchantLegalInfo"
      headerContent={<span>{t('Partner Information')}</span>}
      onClose={onClose}
      bodyContent={<MerchantLegalInfoContent merchantInfo={merchantInfo} />}
      footerContent={
        <SecondaryContentPopperButton
          data-testid="merchantLegalInfoCloseButton"
          label={t('Close')}
          onClick={onClose}
        />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  z-index: ${Z_INDEXES.SUSTAINABILITY_MODAL_DIALOG};
`;
